import React from 'react';
import { useHistory } from 'react-router-dom';
import classes from './ExpandedPanel.module.css';
import { AppUtils } from '@gscope-mfe/app-bridge';
import strideLogo from '../../assets/logo-stride-color.png';
import StrideProfile from '../StrideProfile/StrideProfile';
import StrideMarket from '../StrideMarket/StrideMarket';
import StrideIcon from '../../assets/index';
import { useTranslation } from 'react-i18next';

const ExpandedPanel = ({ strideBuckets, setExpandedPanel, currentStrideBucket }) => {
    const [focusLowerSection, setFocusLowerSection] = React.useState(0);
    const [showPanel, setShowPanel] = React.useState(false);
    const [hoveredBucket, setHoveredBucket] = React.useState({});
    const [overflowContent, setOverflowContent] = React.useState({});
    const [marketShow, setMarketShow] = React.useState(false);
    const [selectedMarket, setSelectedMarket] = React.useState('');
    const [showProfile, setShowProfile] = React.useState(false);
    const { t } = useTranslation('commonLang');
    const { currentMarket } = AppUtils.get();

    const history = useHistory();
    const panelRef = React.useRef();
    const inputEl = React.useRef([]);
    const profileTab = React.useRef();
    const marketTab = React.useRef();
    const findPositionForOverflow = (panel, referenceBucket) => {
        if (!panel) return;
        const refeleTop = referenceBucket.getBoundingClientRect().top;
        let eleBtm = window.innerHeight - referenceBucket.getBoundingClientRect().bottom;
        if (eleBtm < 0) eleBtm = 0;

        const eleHeight = panel.offsetHeight + 10;
        const vwHeight = window.innerHeight;

        if (vwHeight - refeleTop > eleHeight) {
            //we have space to fit in the element and have it expanded downward
            panel.style.top = `${refeleTop}px`;
        } else if (vwHeight - eleBtm > eleHeight) {
            //we have space to fit in the element and expand it upward

            let yPos = vwHeight - eleBtm - panel.offsetHeight;
            if (yPos < 0) yPos = 0;
            panel.style.top = `${yPos}px`;
        } else {
            if (vwHeight - refeleTop > vwHeight - eleBtm) {
                panel.style.top = `${refeleTop}px`;
                panel.style.maxHeight = `calc(100vh - ${refeleTop}px)`;
            } else {
                panel.style.maxHeight = `calc(100vh - ${eleBtm}px)`;
                let yPos = vwHeight - eleBtm - panel.offsetHeight;
                if (yPos < 0) yPos = 0;
                panel.style.top = `${yPos}px`;
            }
        }
    };
    const showModulesForThisBucket = (bucket, thisEl) => {
        if (bucket['pages'] && Object.keys(bucket['pages']).length > 0) {
            if (!showProfile && !marketShow) {
                setShowPanel(true);
                setHoveredBucket(thisEl);
                setOverflowContent(bucket);
            }
        } else {
            setShowPanel(false);
            setHoveredBucket(thisEl);
            setOverflowContent({});
        }
        setShowProfile(false);
        setMarketShow(false);
    };
    const profileExpanded = () => {
        setShowPanel(false);
        setShowProfile(true);
        setMarketShow(false);
        setFocusLowerSection(0);
    };
    const marketExpanded = () => {
        setFocusLowerSection(1);
        setShowPanel(false);
        setShowProfile(false);
        setMarketShow(true);
    };
    const clickBucket = (bucket) => {
        if (!bucket['pages']) {
            setMarketShow(false);
            setExpandedPanel(false);
            history.push(bucket['route']);
        }
    };

    React.useEffect(() => {
        setSelectedMarket(currentMarket);
    }, [currentMarket]);

    const Panel = () => {
        React.useLayoutEffect(() => {
            if (panelRef.current) {
                let referenceBucket = hoveredBucket;
                findPositionForOverflow(panelRef.current, referenceBucket);
            }
        }, [panelRef]);
        const navigateToPage = (route, bucket) => {
            setExpandedPanel(false);
            history.push(route);
        };
        return (
            <div ref={panelRef} className={classes.overflowPanel}>
                {Object.keys(overflowContent.pages)
                    .sort((a, b) => {
                        if (overflowContent.pages[a].sNo > overflowContent.pages[b].sNo) {
                            return 1;
                        }
                        if (overflowContent.pages[a].sNo < overflowContent.pages[b].sNo) {
                            return -1;
                        }
                    })
                    .map((page, id) => {
                        return (
                            <div
                                data-testid={`overflowModule${id}`}
                                key={id}
                                style={{ height: '55px' }}
                                onClick={() => navigateToPage(overflowContent.pages[page].route, overflowContent)}
                                className={classes.overflowPg}
                            >
                                <div>
                                    <StrideIcon name={overflowContent.pages[page].icon} />
                                </div>
                                <div style={{ marginLeft: '8px' }}>
                                    <span>
                                        {t(overflowContent.pages[page].navKey) == overflowContent.pages[page].navKey
                                            ? overflowContent.pages[page].name
                                            : t(overflowContent.pages[page].navKey)}
                                    </span>
                                </div>
                            </div>
                        );
                    })}
            </div>
        );
    };
    return (
        <React.Fragment>
            <div data-testid="expandedMain" className={classes.expandPanel}>
                <div
                    className={classes.overlay}
                    data-testid="expandedOverlay"
                    onClick={() => {
                        setExpandedPanel(false);
                    }}
                ></div>
                <div data-testid="expandedPanelTitle" className={classes.title}>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <img src={strideLogo} alt="strideLogo" />
                        <span className={classes.Stride}>{t('stride')}</span>
                    </div>
                    <div
                        data-testid="gscopeHome"
                        className={classes.gscopeHome}
                        onClick={() => {
                            history.push('/');
                        }}
                    >
                        <span style={{ color: '#abd5f8' }}>{t('GSCOPE')}</span>
                        <i
                            style={{ paddingBottom: '5px' }}
                            className={`${classes['sct-icon']} sct-icon icon-Home-181x`}
                        />
                    </div>
                </div>
                <hr style={{ height: '1px', backgroundColor: '#004484' }} />
                <div data-testid="expandedAllStrideBuckets" className={classes.midSection}>
                    {strideBuckets &&
                        Object.keys(strideBuckets).length > 0 &&
                        Object.keys(strideBuckets)
                            .sort((a, b) => {
                                if (strideBuckets[a].sNo > strideBuckets[b].sNo) {
                                    return 1;
                                }
                                if (strideBuckets[a].sNo < strideBuckets[b].sNo) {
                                    return -1;
                                }
                            })
                            .map((bucket, index) => {
                                return (
                                    <div
                                        key={index}
                                        ref={(ref) => inputEl.current.push(ref)}
                                        data-testid={'page' + index}
                                        onMouseEnter={() =>
                                            showModulesForThisBucket(strideBuckets[bucket], inputEl.current[index])
                                        }
                                        onClick={() => clickBucket(strideBuckets[bucket])}
                                        className={
                                            `${classes.midSectionModule} ` +
                                            (function () {
                                                if (currentStrideBucket.name == strideBuckets[bucket].name) {
                                                    return ` ${classes.activeBucket}`;
                                                } else if (overflowContent.name == strideBuckets[bucket].name) {
                                                    return ` ${classes.focusMidSection}`;
                                                }
                                            })()
                                        }
                                    >
                                        <StrideIcon name={strideBuckets[bucket].icon} />
                                        <span style={{ marginLeft: '10px' }}>
                                            {t(strideBuckets[bucket].navKey) == strideBuckets[bucket].navKey
                                                ? strideBuckets[bucket].name
                                                : t(strideBuckets[bucket].navKey)}
                                        </span>
                                        {overflowContent.name == strideBuckets[bucket].name ||
                                        (currentStrideBucket.name == strideBuckets[bucket].name &&
                                            strideBuckets[bucket]['pages']) ? (
                                            <i className={`${classes.rightIcon} sct-icon icon-Arrow-Right-18 `}></i>
                                        ) : (
                                            ''
                                        )}
                                    </div>
                                );
                            })}
                </div>
                <div data-testid="lowerSection" className={classes.lowerSection}>
                    <div
                        ref={profileTab}
                        data-testid="profileTabExpanded"
                        className={
                            focusLowerSection == 0
                                ? `${classes.navItemThumbnail} ${classes.focus}`
                                : classes.navItemThumbnail
                        }
                        onClick={profileExpanded}
                    >
                        <i className={`${classes['sct-icon']} icon-User-18 sct-icon`}></i>
                        {t('profile')}
                    </div>
                    <div
                        ref={marketTab}
                        data-testid="marketTabExpanded"
                        className={
                            focusLowerSection == 1
                                ? `${classes.navItemThumbnail} ${classes.focus}`
                                : classes.navItemThumbnail
                        }
                        onClick={marketExpanded}
                    >
                        <i className={`${classes['sct-icon']} icon-Globe-181x sct-icon`}></i>
                        {t('market')}
                    </div>
                </div>
                {marketShow && (
                    <StrideMarket
                        data-testid="marketSelExpanded"
                        marketTab={marketTab}
                        origin="ExpandedPanel"
                        selectedMarket={selectedMarket}
                        setSelectedMarket={setSelectedMarket}
                        setShowMarket={setMarketShow}
                    />
                )}
                {showProfile && (
                    <StrideProfile
                        data-testid="profileSelExpanded"
                        setShowProfile={setShowProfile}
                        profileTab={profileTab}
                        origin="ExpandedPanel"
                    />
                )}
            </div>
            {showPanel && <Panel data-testid="overflowExpanded" />}
        </React.Fragment>
    );
};
export default ExpandedPanel;
